export default __webpack_public_path__ + "static/media/sm.63de5ace.png";